// extracted by mini-css-extract-plugin
module.exports = {"taxAndDutiesIncluded":"TaxAndDutiesIncluded_taxAndDutiesIncluded__P6FBo"};